import React from 'react'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, fiscal_years }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title="Geschäftsjahre"
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Geschäftsjahre' },
        ]}
        actions={
          <Button variant="contained" size="small" startIcon={<AddIcon />}
            onClick={() => router.visit(`${basePath}/fiscal_years/new`)}
            data-testid="new-fiscal-year-btn"
          >
            Neues Geschäftsjahr
          </Button>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Zeitraum</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Kontenplan</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Buchungen</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fiscal_years.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Geschäftsjahre vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {fiscal_years.map((fy) => (
              <TableRow key={fy.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/fiscal_years/${fy.id}`)}
              >
                <TableCell>{fy.start_date} – {fy.end_date}</TableCell>
                <TableCell>{fy.chart_of_accounts_name}</TableCell>
                <TableCell>{fy.journal_entries_count}</TableCell>
                <TableCell><StatusBadge type="fiscal_year_status" value={fy.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
